import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: colors.red.lighten3,
        secondary: colors.yellow.lighten3,
        success: '#3cd1c3',
        info: '#ffaa2c',
        error: '#f83e70'
      },
      light: {
        primary: '#FF163E',
        secondary: '#9C27B0',
        success: '#3cd1c3',
        info: '#ffaa2c',
        error: '#f83e70'
        // anchor: '#8c9eff',
      }
    }
  }
})
